module.exports = __webpack_public_path__ + "img/양양 물회.5d822008.png";